<template>
    <div class="mit-page">
        <BaseMitLoading class="mit-progress" :show="loading" :absolute="true"/>
        <v-snackbar :centered="true" :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
            <b>{{ status.message }}</b>
        </v-snackbar>
        <v-dialog v-model="dialogCreateObject" persistent max-width="600px">
          <v-card>
            <v-card-title class="text-h5 primary lighten-2">{{ dialogTitle }}</v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                    <v-form ref="form" class="mx-2" lazy-validation>
                      <v-col cols="12">
                        <v-text-field :disabled="editingObject" :rules="objTypeRule" v-model="obj.type" label="Type*" hint="The type of the object, this should be simple and only letters. Example 'printer'" persistent-hint required></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field v-model="obj.name" label="Name" hint="Default name to give the object when a user creates it."></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model.number="obj.width" min="1" max="200" type="number" label="Width" hint="Default width" required ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model.number="obj.height" min="1" max="200" type="number" label="Height" hint="Default height" required ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                          <v-select :items="[{
                                                text:'False',
                                                value:false
                                              },
                                              {
                                                  text:'True',
                                                  value:true
                                              }]"
                        label="Active*"
                        required
                        v-model="obj.active"
                      ></v-select>
                      </v-col>
                      <v-col cols="12">
                          <v-file-input v-model="obj.image" accept="image/*" label="Image/Icon" hint="Small file sizes such as PNG files are ideal, 120px X 120px or 120px X 240px or less in size" persistent-hint></v-file-input>
                      </v-col>
                  </v-form>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="resetCreateObject">Cancel</v-btn>
              <v-btn :disabled="obj.type.length === 0" color="blue darken-1" @click="saveObjectDefinition">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-container fluid>
          <v-dialog v-model="dialogTypes" persistent max-width="600px">
              <v-card>
                <v-card-title class="text-h5 primary lighten-2">{{ dialogTypeTitle }}</v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                        <v-form ref="formTypes" class="mx-2" lazy-validation>
                          <v-col cols="12" class="pa-0 ma-0">
                            <v-radio-group v-model="newTypeMatchBySpace" row>
                              <v-radio label="Match Specific Space" :value="true"></v-radio>
                              <v-radio label="Match All Spaces with Type" :value="false"></v-radio>
                            </v-radio-group>
                          </v-col>
                          <v-col cols="12" v-if="newTypeMatchBySpace" class="pa-0 ma-0">
                              <v-autocomplete class="pa-0 ma-0" :rules="typeMatchRule" :clearable="true" dense solo :filter="autocompleteSearch" v-model="newType.mitId" :items="spacesList" label="Space to override" item-text="mitId" item-value="mitId">
                                <template v-slot:item="data">
                                  <template>
                                    <v-list-item-avatar>
                                      <v-icon>mdi-office-building-outline</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <div v-if="data.item.name.length > 0">
                                              <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                              <v-list-item-title v-html="data.item.mitId"></v-list-item-title>
                                              <v-list-item-subtitle v-html="data.item.useType"></v-list-item-subtitle>
                                        </div>
                                        <div v-else>
                                            <v-list-item-title v-html="data.item.mitId"></v-list-item-title>
                                            <v-list-item-subtitle v-html="data.item.useType"></v-list-item-subtitle>
                                        </div>
                                    </v-list-item-content>
                                  </template>
                                </template>
                              </v-autocomplete>
                          </v-col>
                          <v-col cols="12" v-else class="pa-0 ma-0">
                              <v-autocomplete class="pa-0 ma-0" :rules="typeMatchRule" dense solo :clearable="true" label="Type to override" v-model="newType.spacesUseType" :items="spacesTypes"></v-autocomplete>
                          </v-col>
                          <v-col cols="12" class="pa-0 ma-0">
                            <v-text-field class="pa-0 ma-0" dense :rules="newTypeCategoryRule" v-model="newType.overrideUseType" label="New Type" hint="The new type to replace " required ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="pa-0 ma-0">
                            <v-text-field class="pa-0 ma-0" dense :rules="newTypeCategoryRule" v-model="newType.overrideUseCategory" label="New Category" hint="The category of the type" required ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="pa-0 ma-0">
                            <v-checkbox  class="pa-0 ma-0" v-model="newType.showRoomNumber" label="Show Room Number On Map"></v-checkbox>
                          </v-col>
                          <v-col cols="12" class="pa-0 ma-0">
                            <v-checkbox  class="pa-0 ma-0" v-model="newTypeOverrideColor" label="Override Map Color" @click="typeColorClick()"></v-checkbox>
                            <!-- <v-sheet max-height="50px"> -->
                              <v-color-picker v-if="newTypeOverrideColor"
                              canvas-height="100"
                              dot-size="29"
                              hide-mode-switch
                              mode="hexa"
                              v-model="newType.color"
                            ></v-color-picker>
                            <!-- </v-sheet> -->
                            
                          </v-col>
                      </v-form>
                    </v-row>
                  </v-container>
                  <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="resetCreateType">Cancel</v-btn>
                  <v-btn color="blue darken-1" @click="saveType">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-card class="mit-info-card" style="width:100%">
                <v-card-title>App Settings</v-card-title>
                <v-card-subtitle class="caption">Settings for the application and configuration that applies to all buildings.</v-card-subtitle>
                <v-divider></v-divider>

                <!-- Type override -->
                <v-card outlined flat class="mit-info-card" style="width:100%">
                    <v-card-title>Map Space Type Override</v-card-title>
                    <v-card-subtitle class="caption">Change the space types that come default from facilities.</v-card-subtitle>
                    <v-card-text>
                        <v-btn class="mr-4" type="submit"  @click="createType">Create Type</v-btn>
                    </v-card-text>
                    <v-simple-table v-if="typesList.length > 0" class="pa-10" dense fixed-header>
                        <template v-slot:default>
                            <v-container v-if="loadingTypes">
                                <v-row class="fill-height" align-content="center" justify="center">
                                    <v-col class="text-subtitle-1 text-center" cols="12">
                                      Loading Type Overrides...
                                    </v-col>
                                    <v-col cols="6">
                                      <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
                                    </v-col>
                               </v-row>
                            </v-container>
                            <thead v-if="!loadingDefinitions">
                              <tr>
                                  <th class="text-left">
                                      Original Type
                                  </th>
                                  <th class="text-left">
                                      Space Mit Id
                                  </th>
                                  <th class="text-left">
                                      New Type
                                  </th>
                                  <th class="text-left">
                                      New Category
                                  </th>
                                  <th class="text-left">
                                      Color
                                  </th>
                                  <th class="text-left">
                                      Show Room Number On Map
                                  </th>
                                  <th class="text-left">
                                      Actions
                                  </th>
                              </tr>
                            </thead>
                            <tbody v-if="!loadingDefinitions">
                              <tr v-for="t in typesList" :key="t.id">
                                  <td>{{ t.spacesUseType }}</td>
                                  <td>{{ t.mitId }}</td>
                                  <td>{{ t.overrideUseType }}</td>
                                  <td>{{ t.overrideUseCategory }}</td>
                                  <td>{{ t.color }}</td>
                                  <td>{{ t.showRoomNumber }}</td>
                                  <td>
                                      <v-btn small class="mr-4" @click="editType(t)">Edit</v-btn>
                                      <v-btn small class="" @click="deleteType(t)">Delete</v-btn>
                                  </td>
                              </tr>
                            </tbody>
                        </template>
                      </v-simple-table>
                </v-card>

                <!-- Create and edit map objects -->
                <v-card outlined flat class="mit-info-card" style="width:100%">
                    <v-card-title>Map Objects</v-card-title>
                    <v-card-subtitle class="caption">Manage the creatable objects for all maps.</v-card-subtitle>
                    <v-card-text>
                        <v-btn class="mr-4" type="submit"  @click="createObject">Create Object</v-btn>
                    </v-card-text>
                    <v-simple-table v-if="objs.length > 0" class="pa-10" dense fixed-header>
                        <template v-slot:default>
                            <v-container v-if="loadingDefinitions">
                                <v-row class="fill-height" align-content="center" justify="center">
                                    <v-col class="text-subtitle-1 text-center" cols="12">
                                      Loading Map Objects...
                                    </v-col>
                                    <v-col cols="6">
                                      <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
                                    </v-col>
                               </v-row>
                            </v-container>
                            <thead v-if="!loadingDefinitions">
                              <tr>
                                  <th class="text-left">
                                      Icon
                                  </th>
                                  <th class="text-left">
                                      Type
                                  </th>
                                  <th class="text-left">
                                      Name
                                  </th>
                                  <th class="text-left">
                                      Active
                                  </th>
                                  <th class="text-left">
                                      Edit
                                  </th>
                              </tr>
                            </thead>
                            <tbody v-if="!loadingDefinitions">
                              <tr v-for="obj in objs" :key="obj.id">
                                  <td>
                                      <v-img contain max-height="30" max-width="60" :src="obj.iconPath"></v-img>
                                  </td>
                                  <td>{{ obj.type }}</td>
                                  <td>{{ obj.name }}</td>
                                  <td>{{ obj.active }}</td>
                                  <td>
                                      <v-btn small class="mr-4" @click="editObject(obj)">Edit</v-btn>
                                  </td>
                              </tr>
                            </tbody>
                        </template>
                      </v-simple-table>
                </v-card>

            </v-card>
        </v-container>
  </div>
</template>

<script>
  import MitSpacesSettingsService from '../../services/MitSpacesSettingsService.js';
  import MitSpacesService from '../../services/MitSpacesService.js';
  import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';

  export default {
    name: 'MitAdminSettingsPage',
    components: {
        BaseMitLoading
    },
    data: function() {
      return {
          loading:false,
          loadingDefinitions:false,
          dialogCreateObject:false,
          dialogTitle:'',
          status:{
            display:false,
            timeout:3000,
            message:'Saved!',
            color:'primary'
          },
          takenTypes:{},
          editingObject:true,
          obj:{},
          objs:[],
          objTypeRule: [
              (v) => /^[a-zA-Z][a-zA-Z0-9 ]+$/.test(v) || 'Name must be alpha numeric and start with a letter',
              (v) => this.takenTypes.hasOwnProperty(v.toUpperCase()) === false || 'Type is already used'
          ],
          //Types variables
          loadingTypes:false,
          dialogTypes:false,
          newTypeMatchBySpace:false,
          newTypeOverrideColor:false,
          dialogTypeTitle:'',
          newType:{},
          typesList:[],
          spacesList:[],
          spacesTypes:[],
          newSelectedType:null,
          newSelectedMitId:null,
          typeMatchRule: [
              (v) => (this.newType.spacesUseType !== null || this.newType.mitId !== null) || 'Must selected a space mit id OR a type to override'
          ],
          newTypeCategoryRule: [
              (v) => /^[a-zA-Z][a-zA-Z0-9 ]+$/.test(v) || 'Name must be alpha numeric and start with a letter'
          ],
          settingsService: new MitSpacesSettingsService()
      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    created() {
        //get current settings
        this.resetCreateType();
        this.resetCreateObject();
        this.getObjectDefinitions();
        this.getSpacesList();
        this.getBuildingInfo();
        this.getTypeOverrideList();
    },
    methods: {
        getTypeOverrideList(){
          this.settingsService.getTypeOverrides()
                .then( (data)=> {
                    this.typesList = data.types;
                })
                .catch( (error)=> {
                    console.log('An error occurred', error);
                })
        },
        getSpacesList(){
            MitSpacesService.getAllSpacesList()
                .then( (data)=> {
                    this.spacesList = data.spaces;
                })
                .catch( (error)=> {
                    console.log('An error occurred', error);
                })
        },
        getBuildingInfo(){
            MitSpacesService.getAllBuildingStats()
                .then( (data)=> {
                    this.spacesTypes = data.statsOriginal.useType;
                })
                .catch( (error)=> {
                    console.log('An error occurred', error);
                });

        },
        autocompleteSearch(item, queryText, itemText) {
          const textMitIdShort = item.mitId.toLowerCase();
          const textUse = item.useType.toLowerCase()
          const textName = item.name.toLowerCase()
          const searchText = queryText.toLowerCase()

          return textMitIdShort.indexOf(searchText) > -1  || textUse.indexOf(searchText) > -1  || textName.indexOf(searchText) > -1
        },
        resetCreateType(){
          this.dialogTypes = false;
          this.newType = {
             id:null,
             spacesUseType:null,
             mitId:null,
             overrideUseType:'',
             overrideUseCategory:'',
             showRoomNumber:false,
             color:'#FFFFFF'
         };
      },
        createType(){
          this.resetCreateType();
          this.dialogTypeTitle = 'Create Space Type Override';
          this.dialogTypes = true;
        },
        editType(typeModel){
            this.dialogTitle = 'Edit Type Override';
            this.dialogTypes = true;
            if(typeModel.color){
              this.newTypeOverrideColor = true;
            }
            this.newType = {
              id:typeModel.id,
              spacesUseType:typeModel.spacesUseType,
              mitId:typeModel.mitId,
              overrideUseType:typeModel.overrideUseType,
              overrideUseCategory:typeModel.overrideUseCategory,
              showRoomNumber:typeModel.showRoomNumber,
              color:typeModel.color
           };
        },
        typeColorClick(){
          if(this.newTypeOverrideColor === false){
                this.newType.color = null;
          }
          else{
            this.newType.color = '#FFFFFF';
          }
        },
        deleteType(typeModel){
          this.settingsService.deleteTypeOverrides(typeModel.id)
                  .then((results) => {
                      this.loading = false;
                      this.status.message = 'deleted!';
                      this.status.display = true;
                      this.getTypeOverrideList();
                  })
                  .catch((error)=>{
                      this.loading = false;
                      this.status.message = 'An error occurred trying to delete.';
                      this.status.display = true;
                      this.getTypeOverrideList();
                  });
        },
        saveType(){
          if( this.$refs.formTypes.validate() === true){
              this.loading = true;
              //clear out the color
              if(this.newTypeOverrideColor === false){
                this.newType.color = null;
              }
              this.settingsService.saveTypeOverride(this.newType)
                  .then((results) => {
                      this.loading = false;
                      this.status.message = 'Saved!';
                      this.status.display = true;
                      this.resetCreateType();
                      this.getTypeOverrideList();
                  })
                  .catch((error)=>{
                      this.loading = false;
                      this.status.message = 'An error occurred trying to save.';
                      this.status.display = true;
                      this.resetCreateType();
                  });
          }
        },
        createObject(){
            this.resetCreateObject();
            this.editingObject = false;
            this.dialogTitle = 'Create Object';
            this.dialogCreateObject = true;
        },
        editObject(obj){
            this.editingObject = true;
            this.dialogTitle = 'Edit Object';
            this.dialogCreateObject = true;
            this.obj = {
               id:obj.id,
               type:obj.type,
               name:obj.name,
               color:obj.color,
               icon:obj.icon,
               width:obj.width,
               height:obj.height,
               active:obj.active,
               image:obj.image
           };
        },
      resetCreateObject(){
          this.dialogCreateObject = false;
          this.editingObject = false;
          this.obj = {
             id:null,
             type:'',
             name:'',
             icon:null,
             color:null,
             width:10,
             height:10,
             active:true,
             image:''
         };
      },
      getObjectDefinitions(){
          this.loadingDefinitions = true;
          this.settingsService.getObjectDefinitions()
              .then((data) => {
                  this.loadingDefinitions = false;
                  this.objs = data.definitions;

                  //reload a dictionary of taken types so during create we can protect against
                  //using types that are already created.
                  this.takenTypes = {};
                  for(let x = 0; x < this.objs.length; x++){
                      this.takenTypes[this.objs[x].type] = true;
                  }
              })
              .catch((error)=>{
                  this.loadingDefinitions = false;
              })
      },
      saveObjectDefinition() {
          if( this.editingObject || this.$refs.form.validate() === true){
              this.loading = true;
              this.settingsService.saveObjectDefinition(this.obj)
                  .then((results) => {
                      this.loading = false;
                      this.status.message = 'Saved!';
                      this.status.display = true;
                      this.resetCreateObject();
                      this.getObjectDefinitions();
                  })
                  .catch((error)=>{
                      this.loading = false;
                      this.status.message = 'An error occurred trying to save.';
                      this.status.display = true;
                      this.resetCreateObject();
                  });
          }

      }

    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
